module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_8017.ec35514b.png";